import { PackageRequirementsModel } from "../models/PackageRequirementsModel";
import { ApiService } from "./ApiService";
import { IPackagesApiService } from "./IPackagesApiService";

export class PackagesApiService extends ApiService implements IPackagesApiService {
    constructor(baseUrl: string, language?: string) {
        super(baseUrl, language);
    }

    public getPackageRequirements(): Promise<PackageRequirementsModel> {
        return this.get<PackageRequirementsModel>("packages/requirements");
    }
}
